export const connection_string = process.env.REACT_APP_API_BASE_URL || 'http://localhost:16410/api/v1';
export const adminV1Base = process.env.REACT_APP_ADMIN_V1_BASE_URL || 'http://localhost:16410/api/v1';
export const image_url = process.env.REACT_APP_IMAGE_URL || 'http://localhost:16410/';
export const socket_url = process.env.REACT_APP_SOCKET_URL || 'http://localhost:16410/';